//Helpers
import { shellyId16 } from '../../../helpers/interface_helpers';
import { translateIntervals } from './intervals_helpers';

//Types
import type { IChartTempSchedule, ITempSchemeObj } from '../../../types/TemperatureSchemeType';

export const extractHexId = (devTr: string): string => {
	if (devTr === '') return undefined;
	let [_dev = 'dev', main_decimal_id = '', action = 'r1'] = devTr.split(':');
	let channel = Number(action.charAt(1)) - 1;
	let main_hex = shellyId16(main_decimal_id);
	return channel === 0 || isNaN(channel) ? main_hex : `${main_hex}_${channel}`;
};

export const translate_sensor_to_composed_ui_id = (sensor: string) => {
	let split_sensor_trigger = sensor.split(':');
	let device_id = shellyId16(split_sensor_trigger[1]);
	let ext_id_or_ch = 0;
	if (split_sensor_trigger[2] !== 'tmp' && !/^(number|boolean)\d{2}/.test(split_sensor_trigger[2])) {
		ext_id_or_ch = Number(split_sensor_trigger[2].split('t')[1]) - 1;
		return device_id + '|TMP|' + ext_id_or_ch;
	}

	return device_id;
};

export const translateThermostat = (temp_scheme_object: ITempSchemeObj): IChartTempSchedule => {
	let units: 'C' | 'F' = temp_scheme_object?.isinfh ? 'F' : 'C';
	let deftemp = temp_scheme_object?.deftemp;
	let base: number =
		typeof deftemp === 'undefined' || deftemp === null ? (units.match('C') ? 20 : 72) : deftemp;

	return {
		base,
		units,
		type: temp_scheme_object?._meta?.type as 'cool' | 'heat',
		intervals: translateIntervals(temp_scheme_object),
		_enabled: temp_scheme_object._enabled,
	};
};
